/**
 * 通用分页控件,供用户列表(§8.1)、审计日志(§10.1)等列表页复用。
 * 纯展示组件,不持有页码状态,由调用方管理 page/pageSize。
 */
export function Pagination({
  page,
  totalPages,
  total,
  onPageChange,
}: {
  page: number;
  totalPages: number;
  total: number;
  onPageChange: (page: number) => void;
}) {
  if (total === 0) return null;

  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        gap: 8,
        marginTop: 12,
        fontSize: 13,
        color: "#64748b",
      }}
    >
      <span>
        共 {total} 条,第 {page} / {Math.max(totalPages, 1)} 页
      </span>
      <button disabled={page <= 1} onClick={() => onPageChange(1)}>
        首页
      </button>
      <button disabled={page <= 1} onClick={() => onPageChange(page - 1)}>
        上一页
      </button>
      <button disabled={page >= totalPages} onClick={() => onPageChange(page + 1)}>
        下一页
      </button>
      <button disabled={page >= totalPages} onClick={() => onPageChange(totalPages)}>
        末页
      </button>
    </div>
  );
}
